import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  /** Сколько секунд осталось на момент рендера */
  remainingSeconds: number;
  /** Unix секунды, когда был получен snapshot (для корректного пересчёта при ре-рендере) */
  fetchedAt: number;
  className?: string;
  onExpire?: () => void;
}

export function CountdownTimer({ remainingSeconds, fetchedAt, className = '', onExpire }: Props) {
  const { t } = useTranslation();
  const target = fetchedAt + remainingSeconds;
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    const id = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, target - now);
  useEffect(() => {
    if (diff === 0) onExpire?.();
  }, [diff, onExpire]);

  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;

  return (
    <div className={`font-mono tracking-wider ${className}`}>
      <span className="text-valo-red">{String(h).padStart(2, '0')}</span>
      <span className="text-valo-muted mx-0.5">:</span>
      <span>{String(m).padStart(2, '0')}</span>
      <span className="text-valo-muted mx-0.5">:</span>
      <span>{String(s).padStart(2, '0')}</span>
      <span className="sr-only">
        {h}{t('time.hoursShort')} {m}{t('time.minutesShort')} {s}{t('time.secondsShort')}
      </span>
    </div>
  );
}
